import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44720d10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "k-color-space" }

import { ref } from 'vue';
import { useMotions } from '@vueuse/motion';
import { getGameSetTransitions, gameSetLeave } from './transitions';
import ColorButton from './color-button.vue';
import chroma from 'chroma-js';


export default /*#__PURE__*/_defineComponent({
  __name: 'stacked-circle-color-picker',
  props: {
    colors: null
  },
  emits: ['enter', 'select'],
  setup(__props: any, { expose, emit }) {

const { colors = [] } = __props as {
    colors: chroma.Color[]
}




const handleColorSelected = (color: chroma.Color) => {
    emit('select', color);
}

const entered = ref(false);
const handleTransitionComplete = (index: number) => {
    if (entered.value === false && index === colors.length - 1){
        entered.value = true;
        emit('enter');
    }
}

const btnStyle = Phaser.Utils.Array.GetRandom([
    {
        borderRadius: '100%'
    },
    {

    }
])

const getBtnStyle = (index: number) => {
    return {
        width: `${(100 / colors.length) * (index + 1)}%`,
        zIndex: colors.length - index
    }
}

expose({
    leave: () => gameSetLeave(useMotions(), ['collect'])
})

return (_ctx: any,_cache: any) => {
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.colors, (color, i) => {
      return _withDirectives((_openBlock(), _createBlock(ColorButton, _mergeProps({
        color: color.hex(),
        class: "k-pick-color-btn",
        style: getBtnStyle(i),
        onClick: () => handleColorSelected(color)
      }, _unref(getGameSetTransitions)(i, { onComplete: handleTransitionComplete })), null, 16, ["color", "style", "onClick"])), [
        [_directive_motion, `btnMotion${i}`]
      ])
    }), 256))
  ]))
}
}

})